export default "__VITE_ASSET__DOVphEam__"